import { StudentMaterialsPage } from 'src/pages/student/MaterialPage/StudentMaterialsPage';

export default StudentMaterialsPage;
